import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LetterFilelistComponent } from './letter-filelist.component';
import { FileModule } from '@schoolbelle/api/file';

@NgModule({
  declarations: [LetterFilelistComponent],
  imports: [
    CommonModule,
    FileModule,
  ],
  exports: [LetterFilelistComponent],
})
export class LetterFilelistModule { }
